import FileDetail from "../controllers/Repository/FileDetail";
import { rows, DataGrid } from "colbi_web_ui/lib/components";
import { StackLayout } from "../layouts";
import { parseFilter } from "colbi_web_ui/lib/utils";
import Repository from "../controllers/Repository/Repository";
import RepositoryToolbar from "../components/RepositoryToolbar/RepositoryToolbar";
import { getConfigVariable } from "../config/config";

const queries = (args = {}) => {
    return [
        {
            resource: args.section,
            args: {
                projectId: args.projectId,
                fiscalYear: args.fiscalYear || "",
                fileType: args.fileType || "",
                sort: args.sort
                    ? { type: "[SortInput!]", value: parseFilter(args.sort) }
                    : undefined,
                filter: args.filter
                    ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
                    : undefined,
                page: parseInt(args.page, 10) || 0,
                pageSize: parseInt(
                    args.pageSize || getConfigVariable("REACT_APP_DEFAULT_PAGE_SIZE"),
                ),
            },
            body: `__typename, items{...${args.section}}, total, hasMore,filters(projectId:$projectId, fiscalYear:$fiscalYear){ prop, name, type, list, disableOperators, mandatory}`,
            downloadable: true,
            forceRefresh: true,
            isDatagridReq: true,
        },
        {
            resource: "project_modules",
            args: {
                projectId: args.projectId,
            },
            body: "modules",
        },
        args.id
            ? {
                  resource: `${args.section}_detail`,
                  args: {
                      projectId: args.projectId,
                      fiscalYear: args.fiscalYear,
                      id: args.id,
                      locale: args.locale || "",
                  },
                  body: `...${args.section}_detail`,
              }
            : {},
    ].filter((r) => !!r.resource);
};

const submissionSaft = (path, navigation) => ({
    path,
    navigation,
    component: Repository,
    exact: false,
    queries,
    title: "files",
    components: [
        {
            component: DataGrid,
            props: {
                id: "results",
                card: rows.CellCard,
                checkbox: true,
                items: "query(0).list",
                header: "query(0).header",
                footer: "query(0).footer",
                metadata: "query(0).metadata",
                page: "param(page)",
                status: "status(0)",
                sort: "param(sort)",
                pageSize: "param(pageSize)",
                pageDefault: 10,
                filter: "param(filter)",
                availableFilters: "query(0).filters",
                wrapper: "wrapper",
                showCheckbox: "query(0).showCheckbox",
                total: "query(0).metadata.total",
                projectModules: "query(1)",
                hideDeleteSeriesButton: true,
                toolbar: (props) => RepositoryToolbar({ hideSeriesButton: true, ...props }),
            },
        },
    ],
    routes: [
        {
            path: "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear/:importId/repository/:section/:fileType/:id",
            exact: true,
            queries,
            component: StackLayout,
            components: [
                {
                    component: FileDetail,
                    props: {
                        modules: "query(1)",
                        data: "query(2)",
                    },
                },
            ],
        },
    ],
});

export default submissionSaft;
